import { globalOptions } from 'Dictionaries/imports/importOptionsDictionary.js';
import { merge } from 'lodash';

export const options = merge(
    {
        identifiers: {
            contact: {
                title: window.i18n.__('Critère de comparaison pour les contacts'),

                choices: [
                    {
                        value: 'contact_id',
                        label: window.i18n.__('Identifiant contact'),
                        description: window.i18n.__('Récupéré uniquement depuis un export Sellsy.'),
                    },
                    {
                        value: 'contact_last_name',
                        label: window.i18n.__('Nom contact'),
                        description: window.i18n.__('Nom de famille du contact.'),
                    },
                    {
                        value: 'contact_first_name',
                        label: window.i18n.__('Prénom contact'),
                        description: window.i18n.__('Prénom du contact.'),
                    },
                    {
                        value: 'contact_email',
                        label: window.i18n.__('Email contact'),
                        description: window.i18n.__('Adresse email du contact.'),
                    },
                ],
                multiple: true,
            },
        },
        parameters: {},
        description: window.i18n.__(
            'Cette section vous permet de déterminer les critères sur lesquels nous allons déterminer si un contact existe déjà dans vos données Sellsy',
        ),
    },
    globalOptions,
);
export const defaultOptions = {
    identifiers: {
        contact: ['contact_last_name', 'contact_first_name'],
    },
};
